<template>
  <div>
    <div class="img-box">
      <img src="../../img/1_1.jpg" alt="" />
    </div>
    <div class="made">
      <p class="quick">报名免联考国际硕士和博士</p>
      <div class="all">
        <div class="line"></div>
        <div class="now">
          目前已经有 <span>{{ count }} </span>人报名咨询
        </div>
        <div class="line"></div>
      </div>
    </div>
    <!-- 表单 -->
    <form action="" ref="formData" class="form">
      <div class="u-item">
        <div class="name">姓名</div>
        <input type="text" class="input" v-model="formData.name" id="name" />
      </div>

      <div class="u-item">
        <div class="name">手机号码</div>
        <input
          type="tel"
          id="tel"
          v-validate="'required|isMobile'"
          data-vv-name="手机号码"
          :class="colorShow ? 'input' : 'input yellow-border'"
          v-model="formData.mobile"
          ref="mobileInput"
          @blur="mobileBlur"
        />
      </div>

      <div class="u-item">
        <div class="name">验证码</div>
        <div
          class="clearfix"
          style="height: 45px; line-height: 56px; width: 100%"
        >
          <input
            type="tel"
            class="input"
            style="float: left; width: 45%"
            v-validate="'required'"
            data-vv-name="验证码"
            v-model="mobileCode"
            ref="codeInput"
          />
          <span class="float:right;" @click="getCode">{{
            verificationCode
          }}</span>
        </div>
      </div>

      <div class="u-item">
        <div class="name">所在城市</div>
        <div class="option clearfix">
          <select v-model="province">
            <option disabled value="">请选择</option>
            <option
              v-for="(item, index) in areaProvinceList"
              :key="index"
              v-bind:value="item.areaId"
            >
              {{ item.areaName }}
            </option>
          </select>
          <select v-model="city">
            <option disabled value="">请选择</option>
            <option
              v-for="(item, index) in areaCityList"
              :key="index"
              v-bind:value="item.areaId"
            >
              {{ item.areaName }}
            </option>
          </select>
          <select v-model="formData.area" style="margin-right: 0">
            <option disabled value="">请选择</option>
            <option
              v-for="(item, index) in areaList"
              :key="index"
              v-bind:value="item.areaId"
            >
              {{ item.areaName }}
            </option>
          </select>
        </div>
      </div>

      <div class="u-item u-trade">
        <div class="name">所属行业</div>
        <select v-model="formData.trade" id="trade">
          <option disabled value="">请选择</option>
          <option
            v-for="(item, index) in tradeList"
            :key="index"
            v-bind:value="item.value"
          >
            {{ item.value }}
          </option>
        </select>
      </div>
      <div class="submit" @click="saveAllInfo">立即报名</div>
    </form>
    <div class="img-box">
      <img src="../../img/1_2.jpg" alt="" />
    </div>
    <!-- 视频 -->
    <div class="video-box">
      <video controls poster="../../img/video.png">
        <source src="../../img/video/video.mp4" type />
      </video>
    </div>
    <div class="img-box">
      <img src="../../img/1_3.jpg" alt="" />
    </div>
  </div>
</template>

<script>
import {
  getInsert,
  getTradeList,
  getAreaList,
  getCountList,
  advertisersCallback,
  getCodeFun,
  getVerifyCode,
} from "./apis.js";
export default {
  name: "Index",
  data() {
    return {
      formData: {
        name: "",
        mobile: "",
        area: "",
        trade: "",
        channelCode: this.$route.query.channelCode,
      },
      areaProvinceList: [],
      areaList: [],
      areaCityList: [],
      tradeList: [], //所属行业
      areaProvinceId: "",
      areaCityId: "",
      province: "",
      city: "",
      colorShow: true,
      count: 0,
      pValue: "",
      status: true,
      timer: 60,
      verificationCode: "获取验证码",
      codeFocus: false,
      mobileCode: "", //短信验证码
    };
  },
  methods: {
    getCode() {
      if (this.formData.mobile == "") {
        this.$layer.msg("手机号码不能为空", { time: 3 });
        this.$refs.mobileInput.focus();
      } else {
        if (
          this.errors.items.length != 0 &&
          this.errors.items[0].field == "手机号码"
        ) {
          this.$layer.msg(this.errors.items[0].msg, { time: 3 });
          this.$refs.mobileInput.focus();
          this.colorShow = false;
          return;
        }
        if (this.status) {
          this.status = false;
          var count = this.timer;
          this.verificationCode = count + "s后重新获取";
          var timer = setInterval(() => {
            if (count === 0) {
              clearInterval(timer);
              this.verificationCode = "获取验证码";
              this.status = true;
            } else {
              count--;
              this.verificationCode = count + "s后重新获取";
            }
          }, 1000);
          this.$refs.codeInput.focus();
          this.getSmsCode();
        }
      }
    },
    async getSmsCode() {
      //获取验证码
      try {
        let param = {
          mobile: this.formData.mobile,
        };
        let { data } = await getCodeFun(param);
        if (data.code == 1000) {
          this.$layer.msg(data.message, { time: 3 });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getVerifyCode() {
      //验证短信验证码是否正确
      try {
        let param = {
          mobile: this.formData.mobile,
          mobileCode: this.mobileCode,
        };
        let { data } = await getVerifyCode(param);
        if (data.code == 1000) {
          console.log("+++++=");
          console.log("验证短信验证码", data);
          //						this.$layer.msg(data.message, {time: 3});
          this.saveInfo();
        } else {
          console.log("验证码错误");
          this.$layer.msg(data.message, { time: 3 });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async saveInfo() {
      //保存
      try {
        if (this.formData.name == " ") {
          this.formData.name = "";
        }
        let { data } = await getInsert(this.formData);
        if (data.code == 1000) {
          console.log("保存接口返回的数据", data);
          alert(data.message)
          // var others = {
            //这个参数必须是对象
            // 所属行业: this.formData.trade,
            //							}
          // };
          // sendPage($("#tel").val(), $("#name").val(), others, {});
          this.$layer.msg(data.message, { time: 3 });
          // this.advertisersCallback();
        } else {
          console.log("else",data.message)
          alert(data.message)
          this.$layer.msg(data.message, { time: 3 });
          //						this.advertisersCallback();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async advertisersCallback() {
      //广告回调
      try {
        let params = {
          p: this.pValue,
        };
        let { data } = await advertisersCallback(params);
        console.log("广告回调返回数据", data);
      } catch (err) {
        console.log(err);
      }
    },
    saveAllInfo() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          //						this.saveInfo();
          this.getVerifyCode();
        }
        if (this.errors.items[0].rule == "required") {
          this.$layer.msg(`${this.errors.items[0].field}不能为空`, { time: 3 });
          this.$refs.mobileInput.focus();
          this.colorShow = false;
          return;
        }
        if (
          this.errors.items.length != 0 &&
          this.errors.items[0].field == "手机号码"
        ) {
          this.$layer.msg(this.errors.items[0].msg, { time: 3 });
          this.$refs.mobileInput.focus();
          this.colorShow = false;
          return;
        }
      });
    },
    async getTradeList() {
      let params = {
        dictType: "trade_detail",
        pageSize: "10000",
      };
      try {
        let { data } = await getTradeList(params);
        console.log("所属行业数据", data);
        this.tradeList = data.data.content;
      } catch (err) {
        console.log(err);
      }
    },
    async getCountList() {
      //获取人数
      try {
        let { data } = await getCountList();
        this.count = data.data;
      } catch (err) {
        console.log(err);
      }
    },
    mobileBlur() {
      //手机号码input失焦事件
      this.colorShow = true;
    },
    async getAreaList() {
      //获取所在城市
      let parentAreaId = "";
      if (this.province != "" && this.city == "") {
        parentAreaId = this.areaProvinceId;
      } else if (this.province != "" && this.city != "") {
        parentAreaId = this.areaCityId;
      } else {
        parentAreaId = "";
      }
      let params = {
        parentAreaId: parentAreaId,
        pageSize: "10000",
      };
      try {
        let { data } = await getAreaList(params);
        console.log("获取城市数据", data);
        if (parentAreaId != "" && this.areaCityId == "") {
          this.areaCityList = data.data.content; //获取市
        } else if (parentAreaId != "" && this.areaCityId != "") {
          this.areaList = data.data.content; //获取县
        } else {
          this.areaProvinceList = data.data.content; //获取省
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    province: {
      handler: function (val) {
        console.log("val", val);
        this.areaProvinceId = val;
        this.city = "";
        this.formData.area = "";
        this.getAreaList();
      },
    },
    city: {
      handler: function (val) {
        console.log("val", val);
        this.areaCityId = val;
        this.formData.area = "";
        this.getAreaList();
      },
    },
  },
  mounted() {
    this.getCountList();
    this.getAreaList();
    this.getTradeList();
    this.pValue = this.$route.query.p;
    console.log("this.pValue", this.pValue);
  },
};
</script>

<style scoped>
.img-box {
  width: 100%;
  height: auto;
  position: relative;

}
.img-box img {
  display: inline-block;
  width: 100%;
}
/* 视频 */
.video-box {
  width: 100%;
  height: auto;
}
.video-box video {
  width: 100%;
  object-fit: cover;
}
.yellow-border {
  border: 1px solid #f28506 !important;
}

.clearfix:after {
  content: " ";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
}

.banner {
  width: 100%;
  height: 433px;
  background: url("../../img/1.png") no-repeat;
  background-size: 100% 100%;
}

.both {
  padding-top: 20px;
}

.img {
  width: 12%;
  display: inline-block;
  vertical-align: middle;
}

.text {
  color: #fff;
  display: inline-block;
  vertical-align: middle;
  margin-top: 2px;
}

.button div {
  width: 30%;
  height: 32px;
  background: #fff;
  display: inline-block;
  float: left;
  text-align: center;
  line-height: 32px;
  margin-left: 10px;
  opacity: 0.7;
  margin-top: 280px;
  border-radius: 12px;
  margin-bottom: 30px;
}

.made {
  width: 92%;
  background: #fff;
  height: 66px;
  clear: both;
  margin: -85px auto 20px;
  border-radius: 6px;
}

.quick {
  font-size: 20px;
  color: #3e3a39;
  font-weight: bold;
}

.free {
  font-size: 20px;
  color: #f28506;
  font-weight: bold;
}

/*.line {
		width: 28px;
		float: left;
		background: #e7e7e7;
		height: 2px;
		margin-top: 9px;
	}*/

.now {
  text-align: center;
}

.all {
  padding: 0 40px;
  margin-top: 10px;
}

.form {
  margin-bottom: 40px;
}

.u-item {
  width: 80%;
  margin-bottom: 15px;
  margin: 0 auto;
}

.name {
  text-align: left;
  font-size: 16px;
  margin-top: 10px;
}

.input {
  width: 100%;
  height: 35px;
  border: 1px solid #c6cacc;
  margin-top: 10px;
  background: #f6fcff;
  border-radius: 6px;
  padding-left: 15px;
}

.option select {
  width: 30%;
  height: 35px;
  float: left;
  border: 1px solid #c6cacc;
  background: #f6fcff;
  border-radius: 6px;
  margin-top: 10px;
  margin-bottom: 15px;
  outline: none;
  padding-left: 15px;
  margin-right: 5%;
}

.u-trade select {
  width: 100%;
  height: 35px;
  border: 1px solid #c6cacc;
  background: #f6fcff;
  border-radius: 6px;
  margin-top: 10px;
  margin-bottom: 15px;
  outline: none;
  padding-left: 15px;
}

.submit {
  width: 90%;
  height: 40px;
  background: #f28506;
  color: #fff;
  line-height: 40px;
  text-align: center;
  margin: 20px auto;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/sm/bbs.vue